import React from 'react';

const ZoeaLogo = ({ inverted = false, className = '' }) => {
  const ink = inverted ? '#F4F1EA' : '#0E1015';

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} aria-label="Zoea">
      <svg viewBox="0 0 200 200" className="h-full w-auto shrink-0" fill="none" aria-hidden="true">
        <path
          d="M 108.4 32.7 A 70 70 0 1 1 91.6 32.7"
          stroke={ink}
          strokeWidth="5.2"
          strokeLinecap="round"
        />
        <path d="M 100 30 L 100 12" stroke={ink} strokeWidth="5.2" strokeLinecap="round" />
        <circle cx="100" cy="8" r="6" fill="#D4A574" />
      </svg>
      <span
        className="font-['Fraunces'] text-[1.35rem] leading-none tracking-[0.28em] font-light"
        style={{ color: ink }}
      >
        ZOEA
      </span>
    </div>
  );
};

export default ZoeaLogo;
